import { NavLink } from "react-router-dom-v5-compat";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { HOTELS_PATH, useDeviceType } from "@overrides/utilities";
import {
  GuestPicker,
  HotelLocationAutocomplete,
  DateRangePicker,
} from "@tenant/hotels";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import { useHotelSearch } from "../../hooks/useHotelSearch";
import defaultStyles from "./HotelSearch.module.scss";

export type HotelSearchComponentProps = PlatformComponentProps;
export const HotelSearch = ({
  children,
  className,
}: HotelSearchComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelSearch;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();
  const { isDesktopAndUp } = useDeviceType();
  const showMobileHeader = !isDesktopAndUp;

  const { context, handlers } = useHotelSearch();

  return (
    <div className={clsx(block, className)}>
      {showMobileHeader && (
        <div className={cn("mobile-header")}>
          <h1 className={cn("mobile-header-title")}>
            {t("core-hotels.search.startSearch")}
          </h1>
          <NavLink
            className={cn("mobile-header-close")}
            to={HOTELS_PATH}
            aria-label={t("close.button")}
          >
            <Icon iconName={IconNameEnum.close} />
          </NavLink>
        </div>
      )}
      <form className={cn("form")} onSubmit={handlers.onFormSubmit}>
        <HotelLocationAutocomplete
          label={context.locationLabel}
          value={context.place}
          onChange={handlers.handlePlaceChange}
          onFocus={handlers.handlePlaceFocus}
          id="hotel-location-autocomplete"
          className={cn("location-autocomplete")}
          error={context.formError?.place}
        />
        <DateRangePicker
          startDate={context.dateRange?.from}
          endDate={context.dateRange?.until}
          onStartDateChangeHandler={handlers.handleDateRangeFromChange}
          onEndDateChangeHandler={handlers.handleDateRangeUntilChange}
          dialogTitle={t("core-hotels.search.date.mobileTitle")}
          className={cn("date-range-picker")}
          error={context.formError?.dateRange}
        />
        <GuestPicker
          onGuestSelectionHandler={handlers.handleGuestsChange}
          guests={context.guests}
          rooms={context.roomsCount}
          onRoomsSelectionHandler={handlers.handleRoomsCountChange}
          className={cn("guest-picker")}
        />
        <button className={cn("search-button")} type="submit">
          {context.searchButtonLabel}
        </button>
        {children}
      </form>
    </div>
  );
};
